import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { Controller } from 'react-hook-form';
import { Control, FieldError } from 'react-hook-form/dist/types';
import { useTranslation } from 'react-i18next';

import { LabelWithUIGuidelines } from 'component-library/atoms/LabelWithUIGuidelines';
import {
  CivilityFieldWrapper,
  FieldErrorText,
  FormLabelStyled,
  RadioGroupInline,
  RadioLabelStyled,
} from './RHF.styles';

type RHFCivilityFieldProps = {
  /** Nom du champ RHF (ex: 'gender', 'addressGender') */
  name: string;
  control: Control;
  label: string;
  required?: boolean;
  disabled?: boolean;
  error?: FieldError;
  tooltip?: React.ReactNode;
};

/**
 * Champ civilité (radio Mme / M.) compatible React Hook Form v6.
 * Composant générique, réutilisable hors du formulaire d'inscription.
 */
const RHFCivilityField = ({
  name,
  control,
  label,
  required = false,
  disabled = false,
  error,
  tooltip,
}: RHFCivilityFieldProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <FormControl component="fieldset">
      <CivilityFieldWrapper>
        <FormLabel component="legend">
          <FormLabelStyled>
            <LabelWithUIGuidelines label={label} required={required} />
          </FormLabelStyled>
        </FormLabel>
        {tooltip}
        <Controller
          name={name}
          control={control}
          rules={
            required && !disabled
              ? { required: t('core.required') as string }
              : {}
          }
          render={({ onChange, value }) => (
            <RadioGroupInline
              aria-label={name}
              value={value || ''}
              onChange={(e) => !disabled && onChange(e.target.value)}
              row
            >
              <FormControlLabel
                value="0"
                control={<Radio color="primary" />}
                label={
                  <RadioLabelStyled>
                    {t('auth.signup.civility.mrs')}
                  </RadioLabelStyled>
                }
                disabled={disabled}
              />
              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label={
                  <RadioLabelStyled>
                    {t('auth.signup.civility.mr')}
                  </RadioLabelStyled>
                }
                disabled={disabled}
              />
            </RadioGroupInline>
          )}
        />
      </CivilityFieldWrapper>
      {error && (
        <FieldErrorText>
          <Typography variant="caption" color="error">
            {error.message}
          </Typography>
        </FieldErrorText>
      )}
    </FormControl>
  );
};

export default RHFCivilityField;
